export default __webpack_public_path__ + "static/media/42.f15512a6.png";